import * as React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import ConfirmationModal from 'components/modal/ConfirmationModal';

const CommitButton = ({ onCommit, data, ...restProps }) => {
    const [openModal, setOpenModal] = React.useState(false);

    const [additionalProps, setAdditionalProps] = React.useState({});

    const updateProps = props => {
        setAdditionalProps({ ...props });
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleCommit = () => {
        onCommit(data, {
            remove: () => {},
            updateProps,
        });
        handleCloseModal();
    };
    return (
        <>
            <LoadingButton
                color="teal"
                size="small"
                variant="contained"
                loadingIndicator="Saving…"
                onClick={handleCommit}
                {...additionalProps}
                {...restProps}
            >
                Save
            </LoadingButton>
            <ConfirmationModal
                onClose={handleCloseModal}
                isOpen={openModal}
                title="Confirmation"
                renderActions={() => (
                    <>
                        <Button
                            onClick={handleCloseModal}
                            variant="outlined"
                            color="secondary"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleCommit}
                            color="primary"
                            variant="contained"
                        >
                            Save
                        </Button>
                    </>
                )}
            >
                Do you really want to commit data?
            </ConfirmationModal>
        </>
    );
};

CommitButton.propTypes = {
    onCommit: PropTypes.func.isRequired,
    data: PropTypes.object,
};

export default CommitButton;
